// Autobahn (auto.de redesign) — the legacy form dropdown now DELEGATES to the md3 kit
// `FormDropdown` (no MUI MaterialAutocomplete/MaterialSelect). The kit was built to mirror this
// wrapper's exact data contract (single {value,label} / isObj source-object / isMulti array /
// isApiTranslated / namespace label resolution / disableClearable), so every one of the ~150 call
// sites (VehicleEdit & VehicleAdd sections, dealer-profile blocks, EmployeeSet, Contact, modals)
// keeps the same field binding + output and only the markup is re-skinned to md3. The label is
// suppressed via `hideLabel` when an outer FormFieldDropDown owns it.
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { observer } from 'mobx-react';
import { FormDropdown } from '@bytebrand/fe-ui-core-autobahn/ui';
let FormDropDown = class FormDropDown extends React.Component {
    render() {
        const { field, t, namespace, isObj, isApiTranslated, isMulti, disableClearable, freeSolo, disabled, style, className, hideLabel, menuPortal } = this.props;
        return (React.createElement(FormDropdown, { field: field, t: (t || ((k) => k)), namespace: namespace, isObj: isObj, isApiTranslated: isApiTranslated, isMulti: isMulti, disableClearable: disableClearable, freeSolo: freeSolo, disabled: disabled, style: style, className: className, hideLabel: hideLabel, menuPortal: menuPortal }));
    }
};
FormDropDown = __decorate([
    observer
], FormDropDown);
export default FormDropDown;
